import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { createNote, updateNote } from 'actions/notes';
import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { Editor } from 'UI/Inputs';
import Moment from 'moment';
import DateTime from '_class/DateTime';
import DatePicker from 'react-datepicker';
import { Button, Checkbox } from '@haldor/ui';

var NoteForm = /*#__PURE__*/function (_Component) {
  _inherits(NoteForm, _Component);

  var _super = _createSuper(NoteForm);

  function NoteForm(props) {
    var _this;

    _classCallCheck(this, NoteForm);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "getRelationship", function () {
      if (_this.state.relationships != null && _this.state.relationships.length > 0) {
        return _this.state.relationships;
      }

      if (_this.props.references != null) {
        return _this.props.references;
      }

      return {
        'referenceID': _this.props.id,
        'referenceType': _this.props.reference
      };
    });

    _defineProperty(_assertThisInitialized(_this), "required", function (value) {
      if (typeof value !== 'undefined' && value !== '') {
        if (value.length > 199) {
          // Field failed validation, return error for this field (String)
          return _this.props.translate('field-max-200-chars');
        } // Field passes validation, return a undefined error for this field
        // Rule: Not undefined and not an empty string and not over 200 characters


        return undefined;
      } // Field failed validation, return error for this field (String)


      return _this.props.translate('field-needs-input');
    });

    _defineProperty(_assertThisInitialized(_this), "quillValidation", function (value) {
      var strValue = value;
      var text = strValue;

      if (typeof strValue == 'string') {
        //text = strValue.replace(/<(?:.|\n)*?>/gm, '');
        text = text.replace('<p>', '');
        text = text.replace('</p>', '');
        text = text.replace('<br>', '');
      }

      if (text == "" || text == null) {
        return _this.props.translate('write-a-meeting-note');
      }

      return undefined;
    });

    _defineProperty(_assertThisInitialized(_this), "submit", function (values) {
      return new Promise( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resolve) {
          var references;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  values["public"] = !_this.state["private"];
                  values.relationships = [];
                  values.memberships = []; // values.remindDate = this.state.remindDate;

                  references = _this.getRelationship();

                  if (Array.isArray(references) && references.length > 0) {
                    values.relationships = references;
                  } else {
                    values.relationships.push(_this.getRelationship());
                  }

                  if (values.status == null) {
                    values.status = 'CREATED';
                  }

                  if (!(values.id == null)) {
                    _context.next = 11;
                    break;
                  }

                  _context.next = 9;
                  return _this.props.createNote(values);

                case 9:
                  _context.next = 13;
                  break;

                case 11:
                  _context.next = 13;
                  return _this.props.updateNote(values);

                case 13:
                  if (!(_this.props.onAbort != null)) {
                    _context.next = 16;
                    break;
                  }

                  _context.next = 16;
                  return _this.props.onAbort(true, values);

                case 16:
                  resolve(1);

                case 17:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    });

    _defineProperty(_assertThisInitialized(_this), "onCancel", function () {
      if (_this.props.onAbort != null) {
        _this.props.onAbort(false);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onDateChange", function (remindDate) {
      _this.setState({
        remindDate: remindDate
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderInput", function (_ref2) {
      var input = _ref2.input,
          label = _ref2.label,
          type = _ref2.type,
          placeholder = _ref2.placeholder,
          _ref2$meta = _ref2.meta,
          touched = _ref2$meta.touched,
          error = _ref2$meta.error,
          warning = _ref2$meta.warning;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("input", _extends({}, input, {
        placeholder: placeholder || label,
        type: type,
        style: touched && error ? {
          border: '1px solid red'
        } : {}
      })), touched && (error && /*#__PURE__*/React.createElement("span", {
        className: "error"
      }, error) || warning && /*#__PURE__*/React.createElement("span", {
        className: "error"
      }, warning)));
    });

    _defineProperty(_assertThisInitialized(_this), "renderShareCheckbox", function () {
      if (_this.props.disableShare != null) {
        return null;
      }

      var shareLabel = _this.props.translate('private-note');

      if (_this.props.shareLabel != null) {
        shareLabel = _this.props.shareLabel;
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "form-row",
        style: {
          marginTop: 30
        }
      }, /*#__PURE__*/React.createElement(Checkbox, {
        value: _this.state["private"],
        onChange: function onChange(checked) {
          return _this.setState({
            "private": checked
          });
        },
        label: shareLabel
      }));
    });

    var isPublic = true;
    var relationships = []; // let remindDate = null;

    if (props.initialValues != null) {
      if (props.initialValues["public"] != null) {
        isPublic = props.initialValues["public"];
      }

      relationships = props.initialValues.relationships; // remindDate = props.initialValues.remindDate;
    }

    _this.state = {
      // remindDate,
      "private": !isPublic,
      relationships: relationships
    };
    return _this;
  }
  /* Helper methods */


  _createClass(NoteForm, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          submitting = _this$props.submitting,
          handleSubmit = _this$props.handleSubmit,
          valid = _this$props.valid;
      var isEditing = this.props.initialValues != null;
      return /*#__PURE__*/React.createElement("div", {
        className: "form-container"
      }, submitting ? /*#__PURE__*/React.createElement("div", {
        className: "is_sending"
      }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", {
        className: "loading-spinner"
      }))) : null, /*#__PURE__*/React.createElement("form", {
        onSubmit: handleSubmit(this.submit),
        className: "form form-component"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row textarea"
      }, /*#__PURE__*/React.createElement("label", {
        style: {
          marginTop: 0
        }
      }, this.props.translate('text'), "*"), /*#__PURE__*/React.createElement(Field, {
        component: Editor,
        name: "text",
        validate: this.quillValidation,
        placeholder: this.props.translate('write-meeting-note'),
        translate: this.props.translate
      })), this.renderShareCheckbox(), /*#__PURE__*/React.createElement("div", {
        className: "form-divider"
      }), /*#__PURE__*/React.createElement("div", {
        className: "form-row spacing submit"
      }, /*#__PURE__*/React.createElement(Button, {
        disabled: submitting || !valid
      }, this.props.translate('save')), /*#__PURE__*/React.createElement("div", {
        className: "align-right"
      }, /*#__PURE__*/React.createElement(Button, {
        onClick: this.onCancel,
        disabled: submitting,
        type: "secondary"
      }, this.props.translate('Cancel'))))));
    }
  }]);

  return NoteForm;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    initialValues: state.Notes.active
  };
}

export default connect(mapStateToProps, {
  createNote: createNote,
  updateNote: updateNote
})(reduxForm({
  form: 'NoteForm',
  destroyOnUnmount: true
})(NoteForm));